import React from 'react';
import { View, StyleSheet, Pressable } from 'react-native';
import { Text, useTheme as usePaperTheme } from 'react-native-paper';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigation } from '@react-navigation/native';
import { Project } from '../types/project';

type ProjectOptionsScreenProps = {
  route: {
    params: {
      project: Project;
      onEdit: () => void;
      onDelete: () => void;
    };
  };
};

export default function ProjectOptionsScreen({ route }: ProjectOptionsScreenProps) {
  const { project, onEdit, onDelete } = route.params;
  const navigation = useNavigation();
  const { theme } = useTheme();

  const handleEdit = () => {
    onEdit();
    navigation.goBack();
  };

  const handleDelete = () => {
    onDelete();
    navigation.goBack();
  };

  return (
    <View style={[styles.container, { backgroundColor: theme.colors.background }]}>
      <Text style={[styles.title, { color: theme.colors.onBackground }]}>
        {project.name}
      </Text>
      <View style={[styles.card, { backgroundColor: theme.colors.surface }]}>
        <Pressable
          onPress={handleEdit}
          style={[styles.button, { borderBottomWidth: 1, borderBottomColor: theme.colors.outline }]}
        >
          <MaterialCommunityIcons name="pencil" size={24} color={theme.colors.onSurface} />
          <Text style={[styles.buttonText, { color: theme.colors.onSurface }]}>Edit</Text>
        </Pressable>
        <Pressable onPress={handleDelete} style={styles.button}>
          <MaterialCommunityIcons name="delete" size={24} color={theme.colors.error} />
          <Text style={[styles.buttonText, { color: theme.colors.error }]}>Delete</Text>
        </Pressable>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 20,
  },
  card: {
    borderRadius: 12,
    overflow: 'hidden',
    elevation: 4,
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 20,
  },
  buttonText: {
    fontSize: 16,
    marginLeft: 12,
  },
});
